import React from 'react';
import PropTypes from 'prop-types';
import ReactQuill from 'react-quill';
import styled from '@emotion/styled';
import Button from '../Button';
import ButtonGroup from '../ButtonGroup';
import { Flex } from '../Structure';
import 'react-quill/dist/quill.snow.css';
import ContentThemeStyling, { QuillStyleOverride } from './ContentThemeStyling';
import { Select } from '../index';

const propTypes = {
  value: PropTypes.string,
  edit: PropTypes.bool,
  inherit: PropTypes.bool,
  onChange: PropTypes.func,
  onSave: PropTypes.func,
  onCancel: PropTypes.func,
  displayTypeSelect: PropTypes.bool,
  onSelectChange: PropTypes.func,
  dropDownOptions: PropTypes.arrayOf(PropTypes.object),
  indexOfContentType: PropTypes.number,
};

const defaultProps = {
  edit: false,
  inherit: false,
  onChange: null,
  onSave: null,
  onCancel: null,
  value: null,
  displayTypeSelect: false,
  onSelectChange: null,
  dropDownOptions: null,
  indexOfContentType: null,
};


/* If performance issues arise during edit, see
 * https://github.com/zenoamaro/react-quill#using-deltas
 * for more details on possible solutions. Also, consider storing the actual
 * object instead of a stringified version
 */
export default function QuillContent({
  edit,
  inherit,
  onCancel,
  onChange,
  onSave,
  value,
  displayTypeSelect,
  onSelectChange,
  dropDownOptions,
  indexOfContentType,
}) {
  const handleOnChange = (htmlContent, delta, source, editor) => {
    const documentDelta = editor.getContents();
    if (onChange) {
      onChange(JSON.stringify(documentDelta));
    }
  };

  const ListElement = styled.div`
      margin-left:auto;
      margin-right:1em;
      display: block-inline;
    `;

  const emptyDelta = { ops: [] };
  let selectElement;
  if (displayTypeSelect) {
    selectElement = (
      <ListElement>
        <Select
          contentWidth
          name="type"
          defaultSelectedItem={dropDownOptions[indexOfContentType]}
          data={dropDownOptions}
          onChange={item => onSelectChange({ target: { name: 'type', value: item.value } })}
        />
      </ListElement>
    );
  } else {
    selectElement = '';
  }

  // In the future it may be nice to integrate these into the toolbar
  let saveCancelButtons = null;
  if (onCancel || onSave) {
    saveCancelButtons = (
      <Flex marginTop="1em">
        {selectElement}
        <ButtonGroup>
          {onCancel && <Button onClick={onCancel}>Cancel</Button>}
          {onSave && <Button primary onClick={() => onSave(value)}>Save</Button>}
        </ButtonGroup>
      </Flex>
    );
  }

  const quillRendered = (
    <React.Fragment>
      <ReactQuill
        value={(value && JSON.parse(value)) || emptyDelta}
        placeholder="Compose custom content..."
        onChange={handleOnChange}
        readOnly={!edit}
        theme={edit ? undefined /* Default theme */ : null /* Empty theme */}
      />
      {saveCancelButtons}
    </React.Fragment>
  );

  if (inherit) {
    return quillRendered;
  }

  return (
    <ContentThemeStyling>
      <QuillStyleOverride>
        {quillRendered}
      </QuillStyleOverride>
    </ContentThemeStyling>
  );
}

QuillContent.propTypes = propTypes;
QuillContent.defaultProps = defaultProps;
